/* import { replaceContent } from "../utils/html";
import MapEvent from "./MapEvent";

//gsap
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin)

export default class AjaxEvent {
    constructor(el) {
        //div container
        this.el = el;

        this.elms = {
            //filters
            filterWhenMap: this.el.querySelector('[data-hwc-filter-when-map]'),
            filterTiles: this.el.querySelectorAll('[data-hwc-filter-tiles]'),
            filterWhenTiles: this.el.querySelector('[data-hwc-filter-when-tiles]'),
            filterWhereTiles: this.el.querySelector('[data-hwc-filter-where-tiles]'),
            filterEventPassed: this.el.querySelector('[data-hwc-filter-event-passed]'),

            filterWhenMapPhone: this.el.querySelector('[data-hwc-filter-when-map-phone]'),
            filterWhenTilesPhone: this.el.querySelector('[data-hwc-filter-when-tiles-phone]'),
            filterWhereTilesPhone: this.el.querySelector('[data-hwc-filter-where-tiles-phone]'),
            filterEventPassedPhone: this.el.querySelector('[data-hwc-filter-event-passed-phone]'),

            filterEventvalidTilesPhone: this.el.querySelector('[data-hwc-filter-valid-tiles-phone]'),
            filterEventvalidMapPhone: this.el.querySelector('[data-hwc-filter-valid-map-phone]'),
            //container tiles ref
            body: this.el.querySelector('.hwc-BlockEvent-container'),
            //pagination
            pages: this.el.querySelectorAll("[data-archive-page]"),
            pagesPhone: this.el.querySelectorAll("[data-archive-page-phone]"),
        }

        this.init();
    }

    init() {

        if (this.elms.filterTiles) {
            this.elms.filterTiles.forEach((el) => {
                el.addEventListener("change", () => this.filterTiles())
            });
        }

        if (this.elms.filterWhenMap) {
            this.elms.filterWhenMap.addEventListener("change", () => this.filterMap())
        }

        if (this.elms.pages) {
            this.elms.pages.forEach((el) => {
                el.addEventListener("click", (e) => this.changePage(e));
            });
        }
        
        if (this.elms.pagesPhone) {
            this.elms.pagesPhone.forEach((el) => {
                el.addEventListener("click", (e) => this.changePagePhone(e));
            });
        }

        if (this.elms.filterEventvalidTilesPhone) {
            this.elms.filterEventvalidTilesPhone.addEventListener("click", () => this.filterTilesPhone());
        }
        
        if (this.elms.filterEventvalidMapPhone) {
            this.elms.filterEventvalidMapPhone.addEventListener("click", () => this.filterMapPhone());
        }

        if (this.elms.filterEventPassed) {
            this.elms.filterEventPassed.addEventListener("change", () => {
                this.filterMap();
                this.filterTiles();
            });
        }

    }

    changePage(e) {
        e.preventDefault();

        if (e.target.dataset.archivePage == "next") {
            this.setNextPage();
        } else if (e.target.dataset.archivePage == "prev") {
            this.setPrevPage();
        } else {
            this.setPage(e.target.dataset.archivePage);
        }

        this.getConfigTiles();
        this.ajaxProcessTiles();
    }
    
    changePagePhone(e) {
        e.preventDefault();

        if (e.target.dataset.archivePagePhone == "next") {
            this.setNextPage();
        } else if (e.target.dataset.archivePagePhone == "prev") {
            this.setPrevPage();
        } else {
            this.setPage(e.target.dataset.archivePagePhone);
        }

        this.getConfigTilesPhone();
        this.ajaxProcessTiles();
    }

    filterTiles() {
        this.setFirstPage();
        this.getConfigTiles();
        this.ajaxProcessTiles();
    }

    filterTilesPhone() {
        this.setFirstPage();
        this.getConfigTilesPhone();
        this.ajaxProcessTiles();
    }

    filterMap() {
        this.getConfigMap();
        this.ajaxProcessMap();
    }
    
    filterMapPhone() {
        this.getConfigMapPhone();
        this.ajaxProcessMap();
    }

    getConfigTiles() {
        this.config = {
            paged: this.el.querySelector('[data-current-page]') ? this.el.querySelector('[data-current-page]').dataset.currentPage : '',
            where: this.elms.filterWhereTiles.value,
            when: this.elms.filterWhenTiles.value,
            passed: this.elms.filterEventPassed.checked,
            posts_per_page: 1,
        }
    }

    getConfigTilesPhone() {
        this.config = {
            paged: this.el.querySelector('[data-current-page]') ? this.el.querySelector('[data-current-page]').dataset.currentPage : '',
            where: this.elms.filterWhereTilesPhone.value,
            when: this.elms.filterWhenTilesPhone.value,
            passed: this.elms.filterEventPassedPhone.checked,
            posts_per_page: 1,
        }
    }

    getConfigMap() {
        this.config = {
            when: this.elms.filterWhenMap.value,
            passed: this.elms.filterEventPassed.checked,
            posts_per_page: -1,
        }
    }
    
    getConfigMapPhone() {
        this.config = {
            when: this.elms.filterWhenMapPhone.value,
            passed: this.elms.filterEventPassedPhone.checked,
            posts_per_page: -1,
        }
    }

    ajaxProcessTiles() {
        
        var that = this;
        jQuery.ajax({
            url: hwc_vars.ajax_url,
            type: "post",
            data: {
                action: "hwc_ajax_block_event_tiles",
                config: this.config,
            },
            success: (response) => {

                this.timeout = setTimeout(() => {

                    if (!response) {
                        return false;
                    }

                    let data = JSON.parse(response);

                    if (data.html && that.elms.body) {

                        replaceContent(data.html, '[data-replacement-tiles]');

                        if (this.el.querySelectorAll('[data-archive-page]').length) {
                            this.el.querySelectorAll('[data-archive-page]').forEach((el) => {
                                el.addEventListener('click', (e) => this.changePage(e));
                            });
                        }
                        
                        if (this.el.querySelectorAll('[data-archive-page-phone]').length) {
                            this.el.querySelectorAll('[data-archive-page-phone]').forEach((el) => {
                                el.addEventListener('click', (e) => this.changePagePhone(e));
                            });
                        }

                        this.setLastPage(data.last_page);
                        this.setTotalPosts(data.total_posts);

                        if (data.new_url) {
                            window.history.pushState(this.config, '', data.new_url);
                        }

                        gsap.to(window, { duration: 0.6, scrollTo: { y: this.el.getBoundingClientRect().top + window.scrollY - 140 } });
                    }
                }, 500);
            },
        });
    }

    ajaxProcessMap() {

        var that = this;
        jQuery.ajax({
            url: hwc_vars.ajax_url,
            type: "post",
            data: {
                action: "hwc_ajax_block_event_map",
                config: this.config,
            },
            success: (response) => {

                this.timeout = setTimeout(() => {

                    if (!response) {
                        return false;
                    }

                    let data = JSON.parse(response);

                    if (data.html && that.elms.body) {

                        replaceContent(data.html, '[data-replacement-map]');

                        this.setLastPage(data.last_page);
                        this.setTotalPosts(data.total_posts);

                        if (data.new_url) {
                            window.history.pushState(this.config, '', data.new_url);
                        }

                        const mapEvent = document.querySelector('[data-hwc-map-event]');
                        if (mapEvent) {
                            new MapEvent(mapEvent);
                        }

                    }
                }, 500);
            },
        });
    }

    getCurrentPage() {
        if (this.el.querySelector('[data-current-page]')) {
            return Number(this.el.querySelector('[data-current-page]').dataset.currentPage);
        }
    }

    getLastPage() {
        if (this.el.querySelector('[data-last-page]')) {
            return Number(this.el.querySelector('[data-last-page]').dataset.lastPage);
        }
    }

    getTotalPosts() {
        if (this.el.querySelector('[data-total-post]')) {
            return Number(this.el.querySelector('[data-total-post]').dataset.totalPost);
        }
    }

    isLastPage() {
        return this.getLastPage() == this.getCurrentPage();
    }

    setFirstPage() {
        if (this.el.querySelector('[data-current-page]')) {
            this.el.querySelector('[data-current-page]').dataset.currentPage = 1;
        }
    }

    setTotalPosts(value) {
        if (this.el.querySelector('[data-total-post]')) {
            this.el.querySelector('[data-total-post]').dataset.totalPost = value;
        }
    }

    setLastPage(value) {
        if (this.el.querySelector('[data-last-page]')) {
            this.el.querySelector('[data-last-page]').dataset.lastPage = value;
        }
    }

    setPage(value) {
        if (this.el.querySelector('[data-current-page]')) {
            this.el.querySelector('[data-current-page]').dataset.currentPage = value;
        }
    }

    setPrevPage() {
        if (this.el.querySelector('[data-current-page]')) {
            this.el.querySelector('[data-current-page]').dataset.currentPage = this.getCurrentPage() - 1;
        }
    }

    setNextPage() {
        if (this.el.querySelector('[data-current-page]')) {
            this.el.querySelector('[data-current-page]').dataset.currentPage = this.getCurrentPage() + 1;
        }
    }
}
 */

//Claude refactor ------
import { replaceContent } from "../utils/html";
import MapEvent from "./MapEvent";

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default class AjaxEvent {
    constructor(el) {
        this.el = el;
        this.timeout = null;

        this.elms = {
            filterWhenMap: el.querySelector('[data-hwc-filter-when-map]'),
            filterTiles: el.querySelectorAll('[data-hwc-filter-tiles]'),
            filterWhenTiles: el.querySelector('[data-hwc-filter-when-tiles]'),
            filterWhereTiles: el.querySelector('[data-hwc-filter-where-tiles]'),
            filterEventPassed: el.querySelector('[data-hwc-filter-event-passed]'),

            loadingTiles: el.querySelector('.loading-tiles'),
            loadingMap: el.querySelector('.loading-map'),

            filterWhenMapPhone: document.querySelector('[data-hwc-filter-when-map-phone]'),
            filterWhenTilesPhone: document.querySelector('[data-hwc-filter-when-tiles-phone]'),
            filterWhereTilesPhone: document.querySelector('[data-hwc-filter-where-tiles-phone]'),
            filterEventPassedPhone: document.querySelector('[data-hwc-filter-event-passed-phone]'),

            filterEventvalidTilesPhone: document.querySelector('[data-hwc-filter-valid-tiles-phone]'),
            filterEventvalidMapPhone: document.querySelector('[data-hwc-filter-valid-map-phone]'),

            body: el.querySelector('.hwc-BlockEvent-container'),
        };
        
        this.init();
    }

    // ── helpers for repeated DOM access ──

    get currentPageEl() {
        return this.el.querySelector('[data-current-page]');
    }

    get currentPage() {
        return this.currentPageEl ? Number(this.currentPageEl.dataset.currentPage) : 1;
    }

    set currentPage(v) {
        if (this.currentPageEl) this.currentPageEl.dataset.currentPage = v;
    }

    get lastPage() {
        const el = this.el.querySelector('[data-last-page]');
        return el ? Number(el.dataset.lastPage) : 1;
    }

    set lastPage(v) {
        const el = this.el.querySelector('[data-last-page]');
        if (el) el.dataset.lastPage = v;
    }

    get totalPosts() {
        const el = this.el.querySelector('[data-total-post]');
        return el ? Number(el.dataset.totalPost) : 0;
    }

    set totalPosts(v) {
        const el = this.el.querySelector('[data-total-post]');
        if (el) el.dataset.totalPost = v;
    }

    get isLastPage() {
        return this.lastPage === this.currentPage;
    }

    // ── init ──

    init() {
        const { elms } = this;

        this.addChangeListeners(elms.filterTiles, () => this.filterTiles());

        this.addChangeListener(elms.filterWhenMap, () => this.filterMap());

        this.bindPageButtons('[data-archive-page]', (e) => this.handlePage(e, 'archivePage'));
        this.bindPageButtons('[data-archive-page-phone]', (e) => this.handlePage(e, 'archivePagePhone'));

        this.addClickListener(elms.filterEventvalidTilesPhone, () => this.filterTiles(true));
        this.addClickListener(elms.filterEventvalidMapPhone, () => this.filterMap(true));

        this.addChangeListener(elms.filterEventPassed, () => {
            this.filterMap();
            this.filterTiles();
        });
    }

    // ── event binding helpers ──

    addChangeListeners(nodeList, handler) {
        if (nodeList) nodeList.forEach((el) => el.addEventListener("change", handler));
    }

    addChangeListener(el, handler) {
        if (el) el.addEventListener("change", handler);
    }

    addClickListener(el, handler) {
        if (el) el.addEventListener("click", handler);
    }

    bindPageButtons(selector, handler) {
        this.el.querySelectorAll(selector).forEach((el) => {
            el.addEventListener("click", handler);
        });
    }

    // ── pagination ──

    handlePage(e, dataKey) {
        e.preventDefault();
        const val = e.target.dataset[dataKey];

        if (val === "next") {
            this.currentPage = this.currentPage + 1;
        } else if (val === "prev") {
            this.currentPage = this.currentPage - 1;
        } else {
            this.currentPage = val;
        }

        const isPhone = dataKey === 'archivePagePhone';
        this.buildTilesConfig(isPhone);
        this.ajaxProcessTiles();
    }

    // ── filters ──

    filterTiles(isPhone = false) {
        this.currentPage = 1;
        this.buildTilesConfig(isPhone);
        this.ajaxProcessTiles();
    }

    filterMap(isPhone = false) {
        this.buildMapConfig(isPhone);
        this.ajaxProcessMap();
    }

    // ── config builders ──

    buildTilesConfig(isPhone) {
        const { elms } = this;
        this.config = {
            paged: this.currentPage,
            where: isPhone ? elms.filterWhereTilesPhone.value : elms.filterWhereTiles.value,
            when: isPhone ? elms.filterWhenTilesPhone.value : elms.filterWhenTiles.value,
            passed: isPhone ? elms.filterEventPassedPhone.checked : elms.filterEventPassed.checked,
            posts_per_page: 6,
        };
    }

    buildMapConfig(isPhone) {
        const { elms } = this;
        this.config = {
            when: isPhone ? elms.filterWhenMapPhone.value : elms.filterWhenMap.value,
            passed: isPhone ? elms.filterEventPassedPhone.checked : elms.filterEventPassed.checked,
            posts_per_page: -1,
        };
    }

    // ── AJAX ──

    ajaxProcessTiles() {
        this.clearPendingTimeout();

        jQuery.ajax({
            url: hwc_vars.ajax_url,
            type: "post",
            data: {
                action: "hwc_ajax_block_event_tiles",
                config: this.config,
            },
            beforeSend: function () {
                this.elms.loadingTiles.classList.toggle('hidden');
            }.bind(this),
            success: (response) => {
                this.timeout = setTimeout(() => {
                    if (!response) return;

                    const data = JSON.parse(response);
                    if (!data.html || !this.elms.body) return;

                    replaceContent(data.html, '[data-replacement-tiles]');
                    this.elms.loadingTiles.classList.toggle('hidden');

                    // rebind pagination after DOM replacement
                    this.bindPageButtons('[data-archive-page]', (e) => this.handlePage(e, 'archivePage'));
                    this.bindPageButtons('[data-archive-page-phone]', (e) => this.handlePage(e, 'archivePagePhone'));
                    this.elms.loadingTiles = this.el.querySelector('.loading-tiles'),

                    this.lastPage = data.last_page;
                    this.totalPosts = data.total_posts;

                    if (data.new_url) {
                        window.history.pushState(this.config, '', data.new_url);
                    }

                    gsap.to(window, {
                        duration: 0.6,
                        scrollTo: { y: this.el.getBoundingClientRect().top + window.scrollY - 140 },
                    });
                }, 500);
            },
        });
    }

    ajaxProcessMap() {
        this.clearPendingTimeout();

        jQuery.ajax({
            url: hwc_vars.ajax_url,
            type: "post",
            data: {
                action: "hwc_ajax_block_event_map",
                config: this.config,
            },
            beforeSend: function () {
                this.elms.loadingMap.classList.toggle('hidden');
            }.bind(this),
            success: (response) => {
                this.timeout = setTimeout(() => {
                    if (!response) return;

                    const data = JSON.parse(response);
                    if (!data.html || !this.elms.body) return;

                    replaceContent(data.html, '[data-replacement-map]');
                    this.elms.loadingMap.classList.toggle('hidden');

                    this.elms.loadingMap = this.el.querySelector('.loading-map'),

                    this.lastPage = data.last_page;
                    this.totalPosts = data.total_posts;

                    if (data.new_url) {
                        window.history.pushState(this.config, '', data.new_url);
                    }

                    const mapEvent = document.querySelector('[data-hwc-map-event]');
                    if (mapEvent) new MapEvent(mapEvent);
                }, 500);
            },
        });
    }

    clearPendingTimeout() {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }
}